/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Tour from 'reactour';
import { Button, Slide, Typography } from '@mui/material';
import pallete from '../../../@core/theme/palette';
import Iconify from '../../../@core/theme/Iconify';

React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

let tourConfig = [];

export default function CustomizedDialogs(props) {
  useEffect(() => {
    tourConfig = [];

    if (
      props.entrevisqualificada == 'Sim' &&
      props.tpbenef !== 'resp_jur' &&
      props.tipooperacao !== 'Cartão' &&
      props.tipooperacao !== 'Odonto'
    ) {
      tourConfig.push(
        {
          updateDelay: 1500,
          selector: '[data-tut="reactour__iso"]',
          content: (
            <Typography variant="subtitle2" component="div">
              <strong>Passo 1 – Visualizar declaração</strong>
              <br />
              Use o botão <strong>Visualizar</strong> para consultar a declaração de saúde do
              beneficiário atual.
            </Typography>
          )
        },
        {
          updateDelay: 1500,
          selector: '[data-tut="reactour__preencher"]',
          content: (
            <Typography variant="subtitle2" component="div">
              <strong>Passo 2 – Botões de ação</strong>
              <br />
              <strong>Preencher:</strong> abre o formulário da declaração (quando estiver pendente).
              <br />
              <strong>Visualizar:</strong> abre a declaração já preenchida para consulta.
              <br />
              <strong>Excluir:</strong> remove a declaração preenchida para permitir novo
              preenchimento.
            </Typography>
          )
        },
        {
          updateDelay: 1500,
          selector: '[data-tut="reactour__avancar"]',
          content: (
            <Typography variant="subtitle2" component="div">
              <strong>Passo 3 – Avançar</strong>
              <br />
              Preencha a declaração de saúde, caso exista, e depois clique em{' '}
              <strong>Próximo</strong> para ir à etapa de assinatura dos documentos.
            </Typography>
          )
        },
        {
          updateDelay: 1500,
          selector: '[data-tut="reactour__assinar"]',
          content: (
            <Typography variant="subtitle2" component="div">
              <strong>Passo 4 – Assinatura e documentos</strong>
              <br />
              Aqui você assina os documentos, baixa os arquivos ou visualiza o contrato. Conclua
              todas as assinaturas e use <strong>Próximo</strong> até finalizar.
            </Typography>
          )
        }
      );
      return;
    }
    if (
      props.tpbenef !== 'resp_jur' &&
      props.tipooperacao !== 'Cartão' &&
      props.tipooperacao !== 'Odonto'
    ) {
      tourConfig.push(
        {
          updateDelay: 1500,
          selector: '[data-tut="reactour__iso"]',
          content: (
            <Typography variant="subtitle2" component="div">
              <strong>Passo 1 – Visualizar declaração</strong>
              <br />
              Use o botão <strong>Visualizar</strong> para consultar a declaração de saúde do
              beneficiário atual.
            </Typography>
          )
        },
        {
          updateDelay: 1500,
          selector: '[data-tut="reactour__preencher"]',
          content: (
            <Typography variant="subtitle2" component="div">
              <strong>Passo 2 – Botões de ação</strong>
              <br />
              <strong>Preencher:</strong> abre o formulário para preencher a declaração de saúde
              (quando ainda estiver pendente).
              <br />
              <strong>Visualizar:</strong> abre a declaração já preenchida para consulta.
              <br />
              <strong>Excluir:</strong> remove a declaração preenchida (permite preencher de novo).
              <br />
              Preencha a declaração de cada beneficiário antes de avançar.
            </Typography>
          )
        },
        {
          updateDelay: 1500,
          selector: '[data-tut="reactour__avancar"]',
          content: (
            <Typography variant="subtitle2" component="div">
              <strong>Passo 3 – Avançar</strong>
              <br />
              Preencha a declaração de saúde, caso exista, e depois clique em{' '}
              <strong>Próximo</strong> para ir à etapa de assinatura dos documentos.
            </Typography>
          )
        },
        {
          updateDelay: 1500,
          selector: '[data-tut="reactour__assinar"]',
          content: (
            <Typography variant="subtitle2" component="div">
              <strong>Passo 4 – Assinatura e documentos</strong>
              <br />
              Assine cada documento pendente no botão <strong>Assinar</strong>. Você também pode
              baixar ou visualizar o contrato. Ao terminar todos, clique em <strong>Próximo</strong>{' '}
              para concluir (ou para baixar os documentos, se houver essa etapa).
            </Typography>
          )
        }
      );
    } else {
      tourConfig.push({
        updateDelay: 1500,
        selector: '[data-tut="reactour__assinar"]',
        content: (
          <Typography variant="subtitle2" component="div">
            <strong>Assinatura de documentos</strong>
            <br />
            Use o botão <strong>Assinar</strong> para assinar os documentos,{' '}
            <strong>Download</strong> para baixar e <strong>Visualizar contrato</strong> para abrir
            o contrato. Após assinar todos, use <strong>Próximo</strong> para continuar ou
            finalizar.
          </Typography>
        )
      });
    }
  }, []);

  const accentColor = pallete.primary.main;
  const [isTourOpen, setTourOpen] = React.useState(false);
  const closeTour = () => {
    setTourOpen(false);
  };
  const openTour = () => {
    setTourOpen(true);
  };
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={openTour}
        sx={{ textTransform: 'none' }}
        startIcon={<Iconify icon="eva:question-mark-circle-outline" />}>
        Dúvidas?
      </Button>
      <Tour
        onRequestClose={closeTour}
        disableInteraction={false}
        steps={tourConfig}
        isOpen={isTourOpen}
        className="helper"
        rounded={5}
        accentColor={accentColor}
      />
    </div>
  );
}
